import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';

const isNative = () => Capacitor.isNativePlatform();

export async function capturePhoto() {
  if (isNative()) {
    const photo = await Camera.getPhoto({
      quality: 85,
      allowEditing: false,
      resultType: CameraResultType.Base64,
      source: CameraSource.Camera,
      correctOrientation: true,
    });
    return {
      base64: photo.base64String,
      mimeType: `image/${photo.format || 'jpeg'}`,
    };
  }
  return webFilePicker(true);
}

export async function pickFromLibrary() {
  if (isNative()) {
    const photo = await Camera.getPhoto({
      quality: 85,
      resultType: CameraResultType.Base64,
      source: CameraSource.Photos,
      correctOrientation: true,
    });
    return {
      base64: photo.base64String,
      mimeType: `image/${photo.format || 'jpeg'}`,
    };
  }
  return webFilePicker(false);
}

function webFilePicker(useCameraCapture) {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    if (useCameraCapture) input.capture = 'environment';
    input.onchange = async () => {
      const file = input.files?.[0];
      if (!file) return resolve(null);
      try {
        const base64 = await fileToBase64(file);
        resolve({ base64, mimeType: file.type || 'image/jpeg' });
      } catch (e) {
        reject(e);
      }
    };
    input.click();
  });
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      const comma = result.indexOf(',');
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
